var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPegasusLogo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 500 500",
  style: {
    enableBackground: "new 0 0 500 500"
  },
  xmlSpace: "preserve",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M339.7,40.2c0,0-13.5-16.4-57.1,5.2c0,0,6.4,6.1,16,6.1c0,0-29.9,11.2-40.3,39.6c0,0,15,6.8,28.2,3.2 c0,0-13.2,16-31.7,18.5c0,0,9.3,7.1,26,4.6c0,0-9.9,5.8-16.6,15.5c-14.9-7.3-36.4-21.5-51.2-46.8c-24.9-42.2-73.7,10.4-180.5,27.6 c0,0,90.7,51.6,127,31.4c0,0-9.8,15.4-39.9,26.8c0,0,61.1,19.4,74.5,12.9c0,0-2.8,10.8-10.5,16.8c0,0,40.7,16.6,86.6,5.1l7.7,2.3 c-5.9,6.5-13.5,12.9-23.1,18.7c-46.1,27.6-44.2,50.4-44.2,50.4s-50.4-1.4-59.4,39.9s6.6,59.9-10.9,84.1c0,0,10.8,0.4,22.7-22.8 c0,0,4,17.1-11.7,41.3c0,0,61.2-28.6,45.9-92.1c0,0-2.9-24.1,12.1-26.2c0,0-4.3,31.8,25.2,46.6c0,0,6.7,19-10.4,41.8 c0,0,2.8,31.4,27.6,58.9c0,0-10.1,6.6-2.1,12.1l-2.4,9.9c0,0,17,3.6,31.6,2.1c0,0-1.4-15.2-10.8-24.8c0,0-21.4-36.4-11.4-50.3 c10-13.9,46.9-23.6,47.4-64.5c0.5-40.9,37.4-30.7,62.4-47.7c25-17.1,30.7-48.5,30.7-48.5s5,7.8,11.1,8.9c6,1.1,29.6-24.6,39.6-26 c10-1.4-2.8,33.1-2.8,33.1s0.1,14.9,10.8,19.6c0,0,15.4-9.7,11.6-38.5c-3.8-28.7-6.2-41.3-25.7-30.4c-19.5,10.9-26.4-4.3-24.5-16.4 c1.9-12.1-2.6-25.9-34-43c-31.4-17.1-28.5-38.8-15.7-37.4c12.8,1.4,23.5,28.9,36,24.6c8-2.7,21.6-19,8.4-29.8 c-13.5-11.1-30.6-65.6-86.2-76.3L339.7,40.2z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  className: "st0"
}, /*#__PURE__*/React.createElement("g", {
  id: "WjtE6u_1_",
  className: "st1"
}, /*#__PURE__*/React.createElement("image", {
  style: {
    overflow: "visible"
  },
  width: 1478,
  height: 1476,
  id: "WjtE6u_2_",
  xlinkHref: "D6651A2E51F891E6.png",
  transform: "matrix(0.3383 0 0 0.3383 0 0)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M259,87"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M325.5,25.5l12,12c0,0-21-13-54,7c0,0,6,8,15,7s-31,6-40,40c0,0,22,6,28,3c0,0-14,15-31,18c0,0,12,7,25,5 c0,0-5.3,17.8-14,20c-8,2-39-65-80-68c-25.6-1.9-137,50-154,43s95,54,126,32c0,0-11,18-38,26c0,0,51,21,73,14c0,0,0,5-9,16 c0,0,56,23,92,8c0,0-67,44-66,70c0,0-79-9-61,101c0,0,0,10-9,21c0,0,8,4,22-21c0,0,6,14-11,40c0,0,63-35,45-93c0,0,1-26,13-24 c0,0-5,35,25,46c0,0,9,12-10,42c0,0,5,38,28,59c0,0-12,6-3,12l-2,10c0,0,27,4,31,2c0,0,2-12-10-25c0,0-22-37-12-51c0,0,58-28,51-82 c0,0,3-22,56-27c0,0,28-13,34-50c0,0,8,11,12,8c0,0,25-22,40-25c0,0,8,3-5,32c0,0,0,14,10,19s26-56,2-71c0,0-47,21-39-25 c0,0-3-19-54-48c0,0-10-18-1-20s32.6,26.1,40,23c12-5,22-9,10-28S358.5,23.5,325.5,25.5z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPegasusLogo);
export default ForwardRef;